module.exports = __webpack_public_path__ + "media/Wizkid-Blow-Prod.-by-Blaqjerzee.503e9233.mp3";